/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { mailBoxPAMDetail } from "../../../Api";

const ActualPam = (props: any) => {

    const { solicitud, handleError } = props;
    const [state, setState] = useState<any>({
        data: {},
        loading: false,
    })

    useEffect(() => {
        _loadData()
    }, [solicitud])

    const _loadData = async () => {
        if (!solicitud) return;
        setState({ ...state, loading: true })
        try {
            const response: any = await mailBoxPAMDetail({ solicitud })
            if (response.data.records instanceof Array) {
                setState({ ...state, data: response.data.records[0], loading: false })
                return;
            }

            if (response.data.records instanceof Object) {
                setState({ ...state, data: response.data.records, loading: false })
                return;
            }
        } catch (e: any) {
            handleError(e)
        }
    }
    return (
        <>

            {state.loading ? (
                <div className="d-flex align-items-center justify-content-center py-5 fs-4 fw-bold">
                    <div className="spinner-border text-secondary me-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    Cargando...
                </div>
            ) : null}
            {!state.loading && (
                <div className="row">
                    <div className="co-12 table-responsive">
                        <table className="table table-bordered table-payment-detailtype">
                            <thead className="fs-6 text-white">
                                <tr>
                                    <th>N° ROL</th>
                                    <th>Número PAM</th>
                                    <th>Medico Tratante</th>
                                    <th>Nombre Paciente</th>
                                    <th>Fecha Alta</th>
                                    <th>Fecha Hospitalización</th>
                                </tr>
                            </thead>
                            <tbody className="fs-6 text-gray-800">
                                <tr>
                                    <td>{state.data?.rol_clinica}</td>
                                    <td>{state.data?.numero_pam}</td>
                                    <td>{state.data?.nombre_profesional}</td>
                                    <td>{state.data?.nombre_paciente_completo}</td>
                                    <td>{state.data?.fecha_alta}</td>
                                    <td>{state.data?.fecha_ingreso}</td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className="text-center">
                                        <img src={state.data?.imagen} className="img-fluid" alt="" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
}

export default ActualPam;